import styled from 'styled-components';
import {Link} from 'react-router-dom';

import {media} from '../../styles/components/media-queries';
import {
  H2,
  H4
} from '../../styles/components/typography.style';
import {ContentStyled} from '../../styles/components/content.style';

export const ContentWrapper = ContentStyled.extend`
  background: ${props => props.theme.galleryPage.backgroundColor};
  text-align: left;
  width: ${props => props.theme.galleryPage.width};
  margin-top: ${props => props.theme.galleryPage.offsetTop};
  ${media.small`
    width: 100%;
    margin: 0;
  `};
`;

export const H2Styled = H2.extend`
  margin-top: ${props => props.theme.margin};
  color: ${props => props.theme.primaryColor};
`;

export const H4Styled = H4.extend`
  margin-top: 0;
  color: ${props => props.theme.primaryColor};
`;

export const MealCardStyled = styled.div`
  margin: ${props => props.theme.galleryPage.mealCard.padding} auto 0;
  background-color: rgba(0, 0, 0, 0.4);
  padding: ${props => props.theme.galleryPage.mealCard.padding};
  display: flex;
  ${media.small`
    display: block;
  `}
`;

export const Img = styled.img`
  width: ${props => props.theme.galleryPage.mealCard.image.width};
  height: ${props => props.theme.galleryPage.mealCard.image.height};
  object-fit: cover;
  flex-shrink: 0;
  ${media.small`
    width: 100%;
    height: 20rem;
  `}
`;

export const MealCardTextWrapper = styled.div`
  padding-left: ${props => props.theme.galleryPage.mealCard.padding};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  -ms-flex: 1 1;
`;

export const P = styled.p`
  line-height: ${props => props.theme.galleryPage.mealCard.fontSize};
`;

export const BottomRow = styled.div`
  font-size: ${props => props.theme.galleryPage.mealCard.fontSize};
  ${media.small`
    text-align: center;
  `}
`;

export const LinkStyled = styled(Link)`
  padding: 1rem 1.8rem;
  background-color: ${props => props.theme.galleryPage.mealCard.orderNowBtn.backgroundColor};
  transition: background-color 0.2s;
  border-radius: 0.5rem;
  border: none;
  border-bottom: 0.2rem solid ${props => props.theme.galleryPage.mealCard.borderColor};
  cursor: pointer;
  color: ${props => props.theme.primaryColor};
  &:hover {
    text-decoration: none;
    background-color: ${props => props.theme.galleryPage.mealCard.orderNowBtn.backgroundHoverColor};
  }
`;

export const OrderNowWrapper = styled.div`
  padding: 0 ${props => props.theme.padding};
`;

export const PriceStyled = styled.span`
  display: inline-block;
  margin-right: 1.2rem;
  padding: 0.8rem 1.8rem;
  border-radius: 2rem;
  border: 1px solid ${props => props.theme.galleryPage.mealCard.borderColor};
`;



// WEBPACK FOOTER //
// ./containers/GalleryPage/GalleryPage.style.js